import { useTranslation } from 'react-i18next'

const ReadyForPickup = () => {
  const { t } = useTranslation(['parking'])
  return (
    <div className="badge ready">
      <div className="header">{t('parking:statusBadge.readyForPickup.header')}</div>
      <div className="subheader">{t('parking:statusBadge.readyForPickup.subheader')}</div>
    </div>
  )
}

export default ReadyForPickup
